import { fetchApi } from '@/config/axiosSetting.ts';
import { PostDamagedVehicleCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedVehicleCorrectiveImages/postDamagedVehicleCorrectiveImages.type';
import { AxiosResponse } from 'axios';

export const postDamagedVehicleCorrectiveImagesFunction = ({
  body,
  damagedId,
  id,
}: PostDamagedVehicleCorrectiveImagesType): Promise<
  AxiosResponse<any, any>
> => {
  return fetchApi({
    method: 'post',
    url: `/property/reports/${id}/accident_users/damaged/images/corrective/send/request/`,
    data: body,
    params: { damaged_id: damagedId },
  });
};
